import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, IconButton, Typography } from "@mui/material";

export const TRANSACTIONAL_DRAWER_PAPER_SX = {
  maxWidth: "100vw",
  overflow: "hidden",
  width: { xs: "100%", sm: 400 },
};

export const TRANSACTIONAL_DRAWER_WIDTHS = {
  compact: 400,
  wide: 600,
};

export const getTransactionalDrawerPaperProps = (
  titleId,
  size = "compact"
) => ({
  "aria-labelledby": titleId,
  role: "dialog",
  sx: {
    ...TRANSACTIONAL_DRAWER_PAPER_SX,
    width: {
      xs: "100%",
      sm:
        TRANSACTIONAL_DRAWER_WIDTHS[size] ||
        TRANSACTIONAL_DRAWER_WIDTHS.compact,
    },
  },
});

export const DrawerLayout = ({ children, sx = {}, ...props }) => (
  <Box
    {...props}
    sx={{
      boxSizing: "border-box",
      display: "flex",
      flex: 1,
      flexDirection: "column",
      minHeight: 0,
      width: "100%",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export const DrawerHeader = ({ children, sx = {}, ...props }) => (
  <Box
    component="header"
    {...props}
    sx={{
      backgroundColor: "background.paper",
      borderBottom: 1,
      borderColor: "divider",
      flexShrink: 0,
      px: 3,
      py: 2,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export const DrawerTitleHeader = ({
  closeLabel,
  closeDisabled = false,
  onClose,
  subtitle,
  title,
  titleId,
  sx = {},
  ...props
}) => (
  <DrawerHeader {...props} sx={sx}>
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        gap: 2,
        justifyContent: "space-between",
      }}
    >
      <Typography
        component="h2"
        id={titleId}
        sx={{ overflowWrap: "anywhere" }}
        variant="h6"
      >
        {title}
      </Typography>
      <IconButton aria-label={closeLabel} edge="end" onClick={onClose} disabled={closeDisabled}>
        <ClearIcon />
      </IconButton>
    </Box>
    {subtitle ? (
      <Typography color="text.secondary" sx={{ mt: 0.5 }} variant="body2">
        {subtitle}
      </Typography>
    ) : null}
  </DrawerHeader>
);

export const DrawerSection = ({
  children,
  description,
  sx = {},
  title,
  titleId,
  ...props
}) => (
  <Box
    aria-labelledby={titleId}
    component="section"
    {...props}
    sx={{
      border: 1,
      borderColor: "divider",
      borderRadius: 2,
      p: 2,
      ...sx,
    }}
  >
    <Box sx={{ mb: 2 }}>
      <Typography
        component="h3"
        id={titleId}
        sx={{ fontWeight: 600 }}
        variant="subtitle1"
      >
        {title}
      </Typography>
      {description ? (
        <Typography color="text.secondary" variant="body2">
          {description}
        </Typography>
      ) : null}
    </Box>
    {children}
  </Box>
);

export const DrawerBody = ({ children, sx = {}, ...props }) => (
  <Box
    {...props}
    sx={{
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      px: 3,
      py: 3,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export const DrawerFooter = ({ children, sx = {}, ...props }) => (
  <Box
    component="footer"
    {...props}
    sx={{
      backgroundColor: "background.paper",
      borderTop: 1,
      borderColor: "divider",
      flexShrink: 0,
      px: 3,
      py: 2,
      ...sx,
    }}
  >
    {children}
  </Box>
);
